<ch-loader [loading]="isInitialLoading"></ch-loader>
<div [ngStyle]="{ display: isInitialLoading ? 'none' : 'block' }">
  <ch-breadcrumb [parts]="['Promo Codes', editMode ? codeName : 'Add New']"></ch-breadcrumb>
  <form (ngSubmit)="edit(form)" #form="ngForm">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-9 col-md-9 pr-5">
          <div class="card mb-9">
            <div class="card-header">Promo code details</div>
            <div class="card-body">
              <div class="form-group">
                <label for="promo-code-edit-title">Title</label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="promoCodeData.name"
                  name="name"
                  #title="ngModel"
                  class="form-control"
                  id="promo-code-edit-title"
                  required
                  [readonly]="loading"
                />
                <small class="text-danger" *ngIf="(title.touched || title.dirty) && !title.valid"> Title is invalid. </small>
              </div>
              <div class="form-group">
                <label for="member-edit-name">Expiry Date</label>
                <ch-datepicker (onChange)="expiryDateChange($event)" [date]="promoCodeData.expiryDate" #expiryDate
                id="promo-code-expiry-date-picker"></ch-datepicker>
                <small class="text-danger" *ngIf="!promoCodeData.expiryDate || ((expiryDate.touched || expiryDate.dirty) && !expiryDate.valid)">
                  Expiry Date is invalid.
                </small>
              </div>
              <div class="form-group">
                <label for="promo-code-edit-usages">Max number of usages</label>
                <input
                  type="number"
                  class="form-control"
                  [(ngModel)]="promoCodeData.maxNumberOfUsages"
                  name="maxNumberOfUsages"
                  #usages="ngModel"
                  class="form-control"
                  id="promo-code-edit-usages"
                  [readonly]="loading"
                />
                <small class="text-danger" *ngIf="(usages.touched || usages.dirty) && !usages.valid">
                  Max number of usages is invalid.
                </small>
              </div>
              <div class="form-group">
                <label for="promo-code-edit-code">Code</label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="promoCodeData.code"
                  name="code"
                  #code="ngModel"
                  class="form-control"
                  id="promo-code-edit-code"
                  required
                  [readonly]="loading"
                />
                <div class="mt-2"><a href (click)="generateRandomCode()">Generate random code</a></div>
                <small class="text-danger" *ngIf="(code.touched || code.dirty) && !code.valid"> Code is invalid. </small>
              </div>
              <div class="form-group">
                <label for="promo-code-type">Type</label>
                <select
                  id="promo-code-type"
                  class="form-control"
                  [(ngModel)]="promoCodeData.type"
                  name="type"
                  #type="ngModel"
                  required
                >
                  <option *ngFor="let option of types" value="{{ option.value }}"> {{ option.text }} </option>
                </select>
                <small class="text-danger" *ngIf="(type.touched || type.dirty) && !type.valid"> Type is invalid. </small>
              </div>

              <div class="form-group">
                <label for="promo-code-type">Free subscription?
                  <small *ngIf='!editMode' class='text-muted'>
                    (this field won't be editable later)
                  </small>
                </label>

                <div class="form-check">
                  <input
                    id="isFreeSubscriptionOptionYes"
                    type="radio"
                    name="isFreeSubscription"
                    #isFreeSubscription="ngModel"
                    ng-control="options"
                    [value]="true"
                    [(ngModel)]="promoCodeData.isFreeSubscription"
                    (change)="toggleFreeSubscription(false)"
                    [attr.disabled]="editMode || null"
                  />
                  <label class="form-check-label" for="isFreeSubscriptionOptionYes">Yes</label>
                </div>
                <div class="form-check">
                  <input
                    id="isFreeSubscriptionOptionNo"
                    type="radio"
                    name="isFreeSubscription"
                    #e1="ngModel"
                    ng-control="options"
                    [value]="false"
                    [(ngModel)]="promoCodeData.isFreeSubscription"
                    (change)="toggleFreeSubscription(true)"
                    [attr.disabled]="editMode || null"
                  />
                  <label class="form-check-label" for="isFreeSubscriptionOptionNo">No</label>
                </div>

                <small class="text-danger" *ngIf="(isFreeSubscription.touched || isFreeSubscription.dirty) && !isFreeSubscription.valid">
                  Free subscription is invalid.
                </small>
              </div>

              <div *ngIf="promoCodeData.isFreeSubscription" class="form-group">
                <label for="free-subscription-duration">Free subscription duration in days (0 or empty for unlimited)</label>
                <input
                  type="number"
                  min="0"
                  class="form-control"
                  [(ngModel)]="promoCodeData.freeSubscriptionDuration"
                  name="freeSubscriptionDuration"
                  #freeSubscriptionDuration="ngModel"
                  class="form-control"
                  id="free-subscription-duration"
                  [readonly]="loading"
                />
                <small class="text-danger" *ngIf="(freeSubscriptionDuration.touched || freeSubscriptionDuration.dirty) && (!freeSubscriptionDuration.valid || freeSubscriptionDuration < 0)">
                  Subsription Duration cannot be negative number
                </small>
              </div>

              <div *ngIf="plansList && showPlans" class="form-group">
                <label for="planId-dropdown">Subscription type</label>
                <select
                  id="planId-dropdown"
                  [(ngModel)]="promoCodeData.planId"
                  name="planId"
                  class="form-control"
                  #planId="ngModel"
                  required
                >
                  <option *ngFor="let plan of plansList" [value]="plan.id"
                    ><span>{{ plan.name }} </span></option
                  >
                </select>
                <small class="text-danger" *ngIf="(planId.touched || planId.dirty) && !planId.valid">
                  Subscription type is required.
                </small>
              </div>

              <div class="form-group" *ngIf="promoCodeData.isFreeSubscription">
                <label for="promo-code-override">Is this a code for a Staff Sub? (Nb: this promo code will cancel any paid subscriptions when applied)</label>

                <div class="form-check">
                  <input
                    id="overridePaidMembershipOptionYes"
                    type="radio"
                    name="overridePaidMembership"
                    #overridePaidMembership="ngModel"
                    ng-control="options"
                    [value]="true"
                    [(ngModel)]="promoCodeData.overridePaidMembership"
                    (change)="toggleOverridePaidMembership(true)"
                  />
                  <label class="form-check-label" for="overridePaidMembershipOptionYes">Yes</label>
                </div>
                <div class="form-check">
                  <input
                    id="overridePaidMembershipOptionNo"
                    type="radio"
                    name="overridePaidMembership"
                    #overridePaidMembership="ngModel"
                    ng-control="options"
                    [value]="false"
                    [(ngModel)]="promoCodeData.overridePaidMembership"
                    (change)="toggleOverridePaidMembership(false)"
                  />
                  <label class="form-check-label" for="overridePaidMembershipOptionNo">No</label>
                </div>

                <small class="text-danger" *ngIf="(overridePaidMembership.touched || overridePaidMembership.dirty) && !overridePaidMembership.valid">
                  Override paid membership is invalid.
                </small>
              </div>

              <div class="form-group" *ngIf="promoCodeData.overridePaidMembership">
                <label for="promo-code-edit-employer-name">
                  Employer Name
                </label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="promoCodeData.employerName"
                  name="employerName"
                  #employerName="ngModel"
                  class="form-control"
                  id="promo-code-edit-employer-name"
                  required
                  [readonly]="loading"
                />
                <small class="text-danger" *ngIf="(employerName.touched || employerName.dirty) && !employerName.valid"> Employer name is invalid. </small>
              </div>

              <div class="form-group">
                <label for="promo-code-edit-notes">Notes</label>
                <textarea
                  type="text"
                  class="form-control"
                  [(ngModel)]="promoCodeData.notes"
                  name="notes"
                  #notes="ngModel"
                  class="form-control"
                  id="promo-code-edit-notes"
                  [readonly]="loading"
                ></textarea>
              </div>

              <div style="margin-top: 40px;">
                <span class="btn-right">
                  <button id='promoCodeEditCancel' type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="loading">Cancel</button>
                  <button id='promoCodeEditSave' type="submit" class="btn btn-primary" [disabled]="loading">Save</button>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-3 col-md-3" *ngIf="editMode">
          <div class="card mb-9">
            <div class="card-header">Statistics</div>
            <div class="card-body">
              <div class="panel-info">
                <p *ngIf="!loaded">...</p>
                <div *ngIf="loaded">
                  <div class="card card-inverse card-important bg-primary" style="margin-bottom: 15px;">
                    <div class="card-body text-center">
                      <a class="text-white" style="text-decoration: none;">
                        <div class="display-6 font-weight-bold">{{ promoCodeData.usagesCount }}</div>
                        <div class="text-uppercase font-weight-bold">Redemptions</div>
                      </a>
                    </div>
                  </div>
                  <div class="card card-inverse card-important bg-primary" style="margin-bottom: 15px;">
                    <div class="card-body text-center">
                      <a class="text-white" style="text-decoration: none;">
                        <div class="display-6 font-weight-bold">{{ promoCodeData.lastUsedAt | dateFormat }}</div>
                        <div class="text-uppercase font-weight-bold">Last Usage</div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/promo-code/promo-code-edit/promo-code-edit.component.html